import React, { useContext, useEffect, useState } from "react";
import { useFormAction, useLocation } from "react-router-dom";
import "./SupportedResourcesDetails.scss";
import { TextContent } from "../../../../../shared/TextContent/TextContent";
import {
  supportedResourcesDetailsData,
  supportedResourceDetailsDataScript,
} from "../SupportedResourcesData";
import DynamicTable from "../../../../../shared/DynamicTable/DynamicTable";
import PointerContent from "../../../../../shared/PointerContent/PointerContent";
import ExternalLinkData from "../../../../../shared/DynamicTable/ExternalLinkData";
import InternalLinkData from "../../../../../shared/DynamicTable/InternalLinkData";
import CustomBreadCrumbs from "../../../../../shared/BreadCrumbs/CustomBreadCrumbs";
import SideBarData from "../../../../Documentation/SideBar/SideBarData";
import MappingTable from "../../../../../shared/DynamicTable/MappingTable";
import { MappingData } from "../../../Mappings/EHConcept/EHCMappingDetails/MappingData";
import capabilityJson from "../../capabilityStatement.json";
import ApiDataService from "../../../../../services/ApiDataService";
import GlobalDataContext from "../../../../../shared/GlobalContext/GlobalDataContext";

function SupportedResourcesDetails() {
  const { metaData, setMetaData } = useContext(GlobalDataContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlValue = queryParams.get("value");
  const [resources, setResources] = useState();
  const [resourceData] = supportedResourceDetailsDataScript.filter(
    (data) => data.name.toLowerCase() === urlValue
  );
  const [resourceDataUpdated, setResourceDataUpdated] = useState();
  const [valueNotFound, setValueNotFound] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [description, setDescription] = useState();
  const [fhirExtension, setFhirExtension] = useState([]);

  // console.log(metaData);

  // const [mappingTableData] = MappingData.table_data.filter(
  //   (data) => data.name.toLowerCase() === urlValue
  // );
  // console.log(mappingTableData);

  // const toMappingFlag = mappingTableData["toFHIRMappingTable"]?.table_heading;
  // const fromMappingFlag =
  //   mappingTableData["fromFHIRMappingTable"]?.table_heading;

  const getDescription = async (type) => {
    try {
      const response = await ApiDataService.getURLContent(
        `https://hl7.org/fhir/${type}.html`
      );
      const parser = new DOMParser();
      const dom = parser.parseFromString(response?.data, "text/html");
      setDescription(
        dom.getElementById("segment-content").getElementsByTagName("p").item(2)
          .outerText
      );
    } catch (error) {
      console.error("Can't fetch Descriptions", error);
    }
  };

  useEffect(() => {
    const json = metaData?.get("capabilityStatement");
    const data = json?.rest[0]?.resource;
    setResources(data);
    
    if (data) {
      const [dataDetails] = data?.filter(
        (d) => d.type.toLowerCase() === urlValue
      );
      setResourceDataUpdated(dataDetails);
      if (!urlValue || !dataDetails[urlValue] || !dataDetails[urlValue].type) {
        setValueNotFound(false);
      }
      // console.log(metaData, metaData?.get("capabilityDescriptions"));
      if (!description) {
        getDescription(urlValue);
      }
      // console.log("FHIR Eextension",fhirExtension);
      if(fhirExtension?.length===0){
        const extensions=metaData?.get("fhirExtensions");
        const lowerCaseExtensn = Object.keys(extensions).reduce((acc, k) =>{
          acc[k.toLowerCase()] = extensions[k];
          return acc;
        }, {});
        // const lowerEtns=lowerCaseExtensn(extensions);
        console.log("FHIR Eextension",lowerCaseExtensn,lowerCaseExtensn[urlValue]);
        setFhirExtension(lowerCaseExtensn[urlValue]);
      }
    }
  }, [metaData, description]);

  if (valueNotFound) {
    return "Value not found";
  }
  const getDocumentationColumn = (text) => {
    if (text.includes("Multiple Resources")) {
      const parts = text.split("*");
      const multiplResource = parts[0].trim();
      const list = parts
        .slice(1)
        .map((value) => value.trim())
        .filter((value) => value !== "");
      return (
        <div>
          <h5>{multiplResource}</h5>
          <div className="multiple-resources">
            <ul>
              {list.map((i) => {
                const name = i.substring(
                  i.indexOf("[") + 1,
                  i.indexOf("(") - 1
                );
                const url = i.substring(i.indexOf("(") + 1, i.indexOf(":") - 1);
                const description = i.substring(i.indexOf(":") + 1);
                return (
                  <li key={i}>
                    <ExternalLinkData
                      value={name}
                      href={`https://hl7.org/fhir/R4/${url}`}
                    />
                    {` : ${description}`}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      );
    }
    return text;
  };
  const extractSearchParamTableData = (resources) => {
    return resources.map((resource) => {
      const resourceObj = { name: "", values: [] };
      resourceObj.name = resource.name;
      //create resource, description, and access values
      resourceObj.values.push(
        { type: "external", value: resource.name, href: resource.definition },
        { type: "text", value: resource.type },
        { type: "text", value: getDocumentationColumn(resource.documentation) }
      );
      return resourceObj;
    });
  };
  const extractFHIRExtensions = (resources) => {
    return resources?.map((resource,index) => {
      const resourceObj = { name: "", values: [] };
      resourceObj.name = index;
      //create resource, description, and access values
      resourceObj.values.push(
        { type: "text", value: resource.source },
        { type: "external", value: resource.extensionURL, href: resource.extensionURL },
        { type: "text", value: resource.FHIRPathExtensionType},
        { type: "text", value: resource.ValueSource }
      );
      return resourceObj;
    });
  };
  return (
    <section className="page-group" id="supported-resources-details">
      {resources && (
        <>
          <CustomBreadCrumbs
            breadcrumbs={[
              `${SideBarData[2].subgroups[0]}`,
              `${resourceDataUpdated.type}`,
            ]}
          />
          <TextContent
            header={`Resource ${
              resourceDataUpdated.type[0].toUpperCase() +
              resourceDataUpdated.type.slice(1)
            }`}
            description={description}
          />
          <div className="supported-interactions">
            <h4>Supported Interactions</h4>
            <ul>
              {resourceDataUpdated?.interaction
                ?.map((i) => i.code)
                .map((interaction) => (
                  <li key={interaction}>
                    <ExternalLinkData
                      value={interaction}
                      href={`https://hl7.org/fhir/R4/http.html#${interaction}`}
                    />
                  </li>
                ))}
            </ul>
          </div>
          {/* addedto make removed code visibile on screen with red line */}
          {/* <div className="supported-interactions supported-interactions-removed">
            <h4>Supported Interactions</h4>
            <ul>
              {resourceData.supportedInteractions.map((interaction) => (
                <li key={interaction}>
                  <ExternalLinkData
                    value={interaction}
                    href={`https://hl7.org/fhir/R4/http.html#${interaction}`}
                  />
                </li>
              ))}
            </ul>
          </div> */}
          <div className="search-parameters">
            <DynamicTable
              title="Search Parameters"
              columns={["Name", "Type", "Documentation"]}
              data={extractSearchParamTableData(
                resourceDataUpdated.searchParam
              )}
            />
          </div>
          {/* should be removed once finalized
          <div className="search-parameters search-parameter-removed">
            <DynamicTable
              title="Search Parameters"
              columns={[
                "Name",
                "Type",
                "Modifiers/Prefixes",
                "Multiple Values",
                "Can be chained",
                "Description",
              ]}
              data={resourceData.searchParameters}
            />
          </div> */}
          {/* need to finalize after discusn */}
          {/* <div className="sorts sort-removed">
            <h4>Sorts</h4>
            <ul>
              {resourceData.sorts.map((sortItem) => (
                <li key={sortItem}>{sortItem}</li>
              ))}
            </ul>
            {resourceData.sorts.length > 1 && (
              <p className="support-desc">Supports multiple sorts</p>
            )}
          </div> */}
          <div className="includes">
            <h4>Search Includes</h4>
            <ul>
              {resourceDataUpdated.searchInclude.map((includeItem) => (
                <li key={includeItem}>{includeItem}</li>
              ))}
            </ul>
          </div>
          <div className="includes">
            <h4>Search Rev Includes</h4>
            <ul>
              {resourceDataUpdated.searchRevInclude.map((includeItem) => (
                <li key={includeItem}>{includeItem}</li>
              ))}
            </ul>
          </div>
          {resourceDataUpdated.operation && (
            <div className="operations">
              <h4>Operations</h4>
              <ul>
                {resourceDataUpdated.operation?.map((item) => {
                  return (
                    <li key={item.name}>
                      <ExternalLinkData
                        value={item.name}
                        href={item.definition}
                      />
                    </li>
                  );
                  // if (item.linkValue === "validate") {
                  //   return (
                  //     <li key={item.linkValue}>
                  //       <ExternalLinkData value={item.linkValue} href={item.href} />
                  //       {` ${item.description}`}
                  //     </li>
                  //   );
                  // } else {
                  //   return (
                  //     <li key={item.linkValue}>
                  //       <InternalLinkData
                  //         value={item.linkValue}
                  //         documentationSection={"supported-system-operations"}
                  //       />
                  //       {` ${item.description}`}
                  //     </li>
                  //   );
                  // }
                })}
              </ul>
            </div>
          )}
          {fhirExtension&&
          <div className="search-parameters">
            <DynamicTable
              title="FHIR extensions"
              columns={[
                "Source",
                "Extension URL",
                "FHIR Path/ Extension Type",
                "Value Source"
              ]}
              data={extractFHIRExtensions(fhirExtension)}
            />
            </div>
          }
          {/* {Object.keys(mappingTableData)
            .filter((key) => key !== "name")
            .map((tableName) => {
              return (
                <div
                  className={`${tableName.toLowerCase()} removed`}
                  key={tableName.toLowerCase()}
                >
                  <MappingTable
                    title={mappingTableData[tableName].table_heading}
                    columns={mappingTableData[tableName].table_columns}
                    values={mappingTableData[tableName].data}
                  />
                </div>
              );
            })} */}
        </>
      )}
    </section>
  );
}

export default SupportedResourcesDetails;
